export const getSalesRepNav = (client: string) => [
  {
    hrefLink: '/salesrep/offerings',
    Icon: 'Properties',
    LinkTitle: 'Offerings',
  },
  {
    hrefLink: '/salesrep/investors',
    Icon: 'Users',
    LinkTitle: client === 'solyco' ? 'Relationships' : 'Investors',
  },
  {
    hrefLink: '/salesrep/profile',
    Icon: 'Profile',
    LinkTitle: 'Profile',
  },
];
